<template>
  <div class="space-y-4">
    <NewSmsMessageAction :contact-request="contactRequest" @created="setLastCreatedAt" />
    <MessageList :key="lastCreatedAt" :contact-request="contactRequest" />
  </div>
</template>

<script>
import NewSmsMessageAction from './NewSmsMessageAction.vue';
import MessageList from './MessageList.vue';

export default {
  components: {
    NewSmsMessageAction,
    MessageList,
  },
  props: {
    contactRequest: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      lastCreatedAt: null,
    };
  },
  methods: {
    setLastCreatedAt() {
      this.lastCreatedAt = new Date().getTime();
    },
  },
};
</script>
